import {
	ContractorListItem,
	ContractorTypeLabels,
	DesignerTypeLabels,
} from "@dune/types";
import { ColumnDef } from "@tanstack/react-table";

export const contractorsColumns: ColumnDef<ContractorListItem>[] = [
	{
		accessorKey: "society.denomination",
		header: "Raison sociale",
		cell: ({ row }) => {
			const contractor = row.original;
			if (contractor.society) {
				return contractor.society.denomination;
			}
			return "-";
		},
	},
	{
		accessorKey: "society.siren",
		header: "Siren",
		cell: ({ row }) => {
			const contractor = row.original;
			if (contractor.society) {
				return contractor.society.siren;
			}
			return "-";
		},
	},
	{
		accessorKey: "type",
		header: "Catégorie",
		cell: ({ row }) => {
			const type = row.original.type;
			const label = ContractorTypeLabels[type] || type;
			return (
				<div
					className={`inline-flex items-center border rounded-full px-2 py-1 text-sm ${
						type === "DESIGNER"
							? "border-blue-badge-border bg-blue-badge-background text-blue-badge-text"
							: "border-purple-badge-border bg-purple-badge-background text-purple-badge-text"
					}`}
				>
					{label}
				</div>
			);
		},
	},
	{
		accessorKey: "designerTypes",
		header: "Type",
		cell: ({ row }) => {
			const contractor = row.original;
			if (contractor.type === "DESIGNER" && contractor.designerTypes?.length) {
				return contractor.designerTypes
					.map((type) => DesignerTypeLabels[type] || type)
					.join(", ");
			}
			if (contractor.type === "MATERIAL" && contractor.materialTypes?.length) {
				return contractor.materialTypes.join(", ");
			}
			return "-";
		},
	},
	{
		accessorKey: "decennialCertificates",
		header: "Activités couvertes",
		cell: ({ row }) => {
			const certificates = row.original.decennialCertificates;
			if (certificates?.length > 0) {
				const allActivities = certificates.flatMap((cert) => cert.activities);
				const uniqueActivities = Array.from(new Set(allActivities));
				return (
					uniqueActivities.slice(0, 3).join(", ") +
					(uniqueActivities.length > 3 ? "..." : "")
				);
			}
			return "-";
		},
	},
	{
		accessorKey: "decennialCertificates",
		header: "Assureur",
		cell: ({ row }) => {
			const certificates = row.original.decennialCertificates;
			if (certificates?.length > 0) {
				return certificates[0]?.insurerSociety?.society?.denomination || "-";
			}
			return "-";
		},
	},
];
